module.exports = __webpack_public_path__ + "static/media/goto_shop.21f68035.png";